import { API_URL } from '../constants';

export const sendStripeReq = async (stripe, card, name) => {
  try {
    const res = await stripe.createPaymentMethod({
      type: 'card',
      card,
      billing_details: {
        name,
      },
    });
    return res;
  } catch (e) {
    return e;
  }
};

export const subscribeToPriceChange = async (pollingId) => {
  const url = `${API_URL}/polling/get-result/${pollingId}`;

  try {
    const data = await fetch(url, { method: 'GET' });
    const response = await data.json();
    const {
      data: { result_data },
    } = response;

    if (data.status === 202) {
      return await subscribeToPriceChange(pollingId);
    }

    return result_data;
  } catch (e) {
    return e.response?.data?.data?.result_data;
  }
};

export const getPollingID = async (
  nonce,
  plan,
  token,
  analyticsParams,
  eventsData,
  onErrorHandler,
  payment_intent_id,
  coupon,
  email = '',
  payment_method = null,
) => {
  const url = `${API_URL}/users/me/subscriptions/polling/${plan}`;
  const requestData = {
    ...analyticsParams,
    user_data: {
      ...analyticsParams['user_data'],
      ...eventsData,
    },
  };

  const body = {
    gateway: 'stripe',
    payment_method_nonce: nonce ?? '',
    coupon: coupon || '',
    payment_intent_id,
    ...requestData,
  };

  const alternatePaymentMethods = [
    'pix_automatico',
    'upi',
    'blik',
    'amazon_pay',
    'revolut_pay',
    'cashapp',
  ];
  if (alternatePaymentMethods.includes(payment_method)) {
    body.payment_method = payment_method;
    if (email) body.user_data = { ...body.user_data, email: String(email).trim() };
  }

  try {
    const data = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });
    const res = await data.json();
    const responseData = res?.data || {};
    if (alternatePaymentMethods.includes(payment_method)) {
      return responseData;
    }
    return responseData.polling_result_id;
  } catch (e) {
    onErrorHandler(e.response?.data?.errors?.messages);
  }
};

export const getSubscriptionID = async (
  nonce,
  plan,
  token,
  analyticsParams,
  eventsData,
  coupon,
) => {
  const url = `${API_URL}/users/me/subscriptions/${plan}`;
  const requestData = {
    ...analyticsParams,
    user_data: {
      ...analyticsParams['user_data'],
      ...eventsData,
    },
  };

  const body = {
    gateway: 'braintree',
    payment_method_nonce: nonce,
    coupon: coupon || '',
    ...requestData,
  };

  try {
    const results = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });
    const res = await results.json();

    return res;
  } catch (e) {
    return e.response?.data || { errors: 'An error has occurred' };
  }
};
